import { Alignment, Button, Colors, Icon, Navbar, Position, Tooltip } from '@blueprintjs/core'
import { lang, ShortcutLabel, utils } from 'enablex/shared'
import cx from 'classnames'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import RoleHeader from '~/app/RoleHeader'
import WorkspaceSelect from '~/app/WorkspaceSelect'

import { getActiveWorkspace } from '~/auth/basicAuth'
import AccessControl from '~/auth/AccessControl'
import UserDropdownMenu from '~/user/UserDropdownMenu'
import { AppState } from '../rootReducer'
import { toggleBottomPanel } from '../uiReducer'
import EnablexLogo from '~/../public/images/enablexLogo.png'
import style from './style.scss'


type Props = ConnectedProps<typeof connector>

const setPageBranding = (branding) => {
  if (branding?.workspaceId && branding?.workspaceId !== 'default') {
    window.APP_NAME = branding.pageTitle || 'EnableX Dialogs'
    window.document.title = window.APP_NAME

    if(branding.faviconURL) {
      const faviconPath = `/api/v1/bots/___/media/${branding.workspaceId}/${branding.faviconURL}`
      window.APP_FAVICON = faviconPath
    } else {
      window.APP_FAVICON = 'assets/admin/ui/public/images/logo-icon.svg'
    }
    const link = document.querySelector('link[rel="icon"]')
    link && link.setAttribute('href', window.APP_FAVICON)

  } else {
    brandDoesNotExist()
  }
}

const brandDoesNotExist = () => {
  window.APP_NAME = 'EnableX Dialogs'
  window.APP_FAVICON = 'assets/admin/ui/public/images/logo-icon.svg'
  window.document.title = window.APP_NAME
  const link = document.querySelector('link[rel="icon"]')
  link && link.setAttribute('href', window.APP_FAVICON)
}

const Header: FC<Props> = props => {
  const localWorkspaceId = getActiveWorkspace()
  const workspaceId = props.currentWorkspace || localWorkspaceId
  let logoURL = ''
  let faviconURL = ''
  const brandingString = localStorage.getItem('enx/branding')
  if(brandingString) {
    const branding = JSON.parse(brandingString)
    logoURL = branding?.logoURL
    faviconURL = branding?.faviconURL
  } else {
    brandDoesNotExist()
  }
  const [brandLogo, setBrandLogo] = useState(logoURL  && workspaceId && workspaceId !== 'default' ? `/api/v1/bots/___/media/${workspaceId}/${logoURL}` : EnablexLogo)

  useEffect(() => {
    setBrandLogo(logoURL && workspaceId && workspaceId !== 'default' ? `/api/v1/bots/___/media/${workspaceId}/${logoURL}`: EnablexLogo)
    if(brandingString) {
      const branding = JSON.parse(brandingString)
      setPageBranding({...branding, workspaceId})
    }
  }, [workspaceId])

  return (
    <header className={cx('bp-header', style.header)}>
      <Navbar>
        <Navbar.Group>
          <Navbar.Heading>
            <div className={cx('bp-sa-title', style.title)}>
              <a href="admin/">
                <img width="19" src={brandLogo || EnablexLogo} alt="Brand Logo" style={{width: '100%', height: '50px'}}/>
              </a>
              {/*{props.pageHelpText && (*/}
              {/*  <Tooltip content={props.pageHelpText}>*/}
              {/*    <Icon icon="info-sign" color={Colors.LIGHT_GRAY1} />*/}
              {/*  </Tooltip>*/}
              {/*)}*/}
            </div>
          </Navbar.Heading>
        </Navbar.Group>
        <Navbar.Group align={Alignment.RIGHT}>
          <RoleHeader/>
          <WorkspaceSelect />
          {props.profile?.isSuperAdmin ? (
          <AccessControl resource="admin.logs" operation="read">
            <Tooltip content={<div className={style.tooltip}>{lang.tr('bottomPanel.label')}</div>}>
              <Button onClick={props.toggleBottomPanel} minimal>
                <Icon color={Colors.BLACK} icon="console" iconSize={16} />
              </Button>
            </Tooltip>
          </AccessControl>
          ):(
          <p></p>
          )}

          <Navbar.Divider />
          <UserDropdownMenu />
        </Navbar.Group>
      </Navbar>
    </header>
  )
}

const mapStateToProps = (state: AppState) => ({
  pageTitle: state.ui.pageTitle,
  pageHelpText: state.ui.pageHelpText,
  profile: state.user.profile,
  currentWorkspace: state.user.currentWorkspace
})

const mapDispatchToProps = { toggleBottomPanel }
const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(Header)
